const prefix = '@MonteiroEng';
export const cookies = {
  AUTH_TOKEN: `${prefix}-AUTH-TOKEN`,
  REFRESH_TOKEN: `${prefix}-REFRESH-TOKEN`,
  PLATFORM_AUTH_TOKEN: `${prefix}-PLATFORM-AUTH-TOKEN`,
  PLATFORM_REFRESH_TOKEN: `${prefix}-PLATFORM-REFRESH-TOKEN`,
  THEME_OPTION: `${prefix}-THEME-OPTION`,
};
